module.exports = require('./clinicinvite');
